module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av562-39138c5f4086ed1293bf9f6ff5a71a0a.jpg";